import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { FaStar, FaStarHalfAlt, FaQuoteLeft } from "react-icons/fa";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BASE_URL } from "../../../../Components/Base_url/Base_Url";
import './Testimonial.css';

const Testimonials = () => {
    const [testimonials, settestimonials] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const res = await fetch(`${BASE_URL}/review/`);
                const json = await res.json();
                if (json?.data) {
                    settestimonials(json.data);
                }
            } catch (err) {
                console.error("Error fetching testimonials:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchReviews();
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 992,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1, arrows: false },
            },
        ],
    };

    const renderStars = (rating) => {
        const stars = [];
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 !== 0;

        for (let i = 0; i < fullStars; i++) {
            stars.push(<FaStar key={`full-${i}`} className="text-warning" />);
        }
        if (hasHalfStar) {
            stars.push(<FaStarHalfAlt key="half" className="text-warning" />);
        }
        return stars;
    };

    return (
        <section className="Review-section py-5">
            <div className="container">
                <div className="text-center mb-5">
                    <h2 className="display-4 fw-bold text-primary mb-3">What Our Customers Say</h2>
                    <p className="lead text-muted">
                        Read genuine reviews from our satisfied customers who have
                        experienced our tours firsthand.
                    </p>
                </div>

                <Slider {...settings}>
                    {testimonials.map((testimonial) => (
                        <div key={testimonial.Testimonial_id} className="px-3">
                            <div className="Review-card card h-100 border-0 shadow-lg position-relative">
                                <div className="card-body p-4">
                                    <div className="Review-quote-icon position-absolute top-0 start-0 mt-3 ms-3">
                                        <FaQuoteLeft className="text-primary opacity-25" size={30} />
                                    </div>
                                    <div className="Review-content mb-4">
                                        <p className="fst-italic text-dark">"{testimonial.Testimonial_quote}"</p>
                                    </div>
                                    <div className="Review-rating mb-3">
                                        {renderStars(testimonial.star)}
                                    </div>
                                    <div className="Review-user d-flex align-items-center">
                                        <div className="Review-user-image me-3">
                                            <img
                                                src={`${BASE_URL}${testimonial.Testimonial_image}`}
                                                alt={testimonial.Testimonial_author}
                                                className="rounded-circle shadow"
                                                width="60"
                                                height="60"
                                            />
                                        </div>
                                        <div className="Review-user-info">
                                            <h5 className="mb-1 fw-bold">{testimonial.Testimonial_author}</h5>
                                            <p className="text-muted mb-0 small">{testimonial.Testimonial_subtext}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </section>
    );
};

export default Testimonials;
